<script lang="ts" setup>
defineProps<{ tournament: Tournament }>()
</script>

<template>
  <div class="flex flex-row gap-1">
    <UiBadge
      v-if="tournament.closed && !tournament.complete"
      variant="success"
    >
      {{ $t('In play') }}
    </UiBadge>
    <UiBadge
      v-else-if="tournament.complete"
      variant="secondary"
    >
      {{ $t('Complete') }}
    </UiBadge>
    <UiBadge
      v-if="tournament.full && (!tournament.url && !tournament.listing_only)"
      variant="destructive"
    >
      {{ $t('Full') }}
    </UiBadge>
    <UiBadge
      v-if="tournament.registration_possible === 'yes'"
      variant="success"
    >
      {{ $t('Registration open') }}
    </UiBadge>
    <UiBadge
      v-if="tournament.registration_possible === 'waiting_list' && tournament.registration_status !== 'on_waiting_list'"
      variant="warning"
    >
      {{ $t('Waiting list open') }}
    </UiBadge>
    <UiBadge
      v-if="tournament.registration_status === 'on_waiting_list'"
      variant="warning"
    >
      <Icon name="tabler-check" />
      {{ $t('On waiting list') }}
    </UiBadge>
    <UiBadge
      v-if="tournament.registration_status === 'registered'"
      variant="success"
    >
      <Icon name="tabler-check" />
      {{ $t('Registered') }}
    </UiBadge>
    <UiBadge
      v-if="tournament.registration_status === 'registered_and_paid'"
      variant="success"
    >
      <Icon name="tabler-check" />
      {{ $t('Paid') }}
    </UiBadge>
  </div>
</template>
